/**
 * Asset host (AO_HOST) for webCOA.
 *
 * Unlike upstream webAO -- which seeds AO_HOST from a URL query param and
 * lets the server override it via the ASS packet -- webCOA's asset base is
 * authoritative from config.json. It is set once during boot via
 * forceSetAOhost() and never overridden afterwards, so a server-sent ASS
 * (or any stray http:// URL) can never cause mixed content or point at the
 * wrong host.
 */

export let AO_HOST = "";

/** Unconditionally set the asset base, normalizing to https on https pages
 * and guaranteeing a single trailing slash. Called once during boot. */
export const forceSetAOhost = (val: string): string => {
  let v = (val || "").trim();
  if (window.location.protocol === "https:" && v.startsWith("http://")) {
    v = "https://" + v.slice("http://".length);
  }
  if (v && !v.endsWith("/")) v += "/";
  AO_HOST = v;
  console.log("Asset base set to " + AO_HOST);
  return AO_HOST;
};

/**
 * Compatibility shim for callers like the ASS handler. webCOA treats the
 * config asset base as authoritative: if it's already set we ignore the
 * incoming value entirely. Only if it was somehow never set do we adopt it.
 */
export const setAOhost = (val: string): string => {
  if (!AO_HOST) return forceSetAOhost(val);
  console.log("Ignoring server-sent asset URL; config base is authoritative");
  return AO_HOST;
};
